import { OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { FuseConfigService } from './../../../@fuse/services/config.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var Error404Component = /** @class */ (function () {
    function Error404Component(fuseTranslationLoaderService, fuseConfigService, router) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.fuseConfigService = fuseConfigService;
        this.router = router;
        this.subscriptions = new Subject();
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.fuseConfigService.config = {
            layout: {
                navbar: {
                    hidden: true
                },
                toolbar: {
                    hidden: true
                },
                footer: {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };
    }
    Error404Component.prototype.ngOnDestroy = function () {
        this.subscriptions.next();
        this.subscriptions.complete();
    };
    Error404Component.prototype.ngOnInit = function () {
        var _this = this;
        this.router.events
            .pipe(takeUntil(this.subscriptions))
            .pipe(filter(function (event) {
            if (!(event instanceof NavigationEnd)) {
                return false;
            }
            return event.urlAfterRedirects === '/404';
        }))
            .subscribe(function () {
            _this.fuseConfigService.config = {
                layout: {
                    navbar: {
                        hidden: true
                    },
                    toolbar: {
                        hidden: true
                    },
                    footer: {
                        hidden: true
                    },
                    sidepanel: {
                        hidden: true
                    }
                }
            };
        });
    };
    return Error404Component;
}());
export { Error404Component };
